var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F6F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 13.04C15.9381 13.04 14.2666 14.6697 14.2666 16.68C14.2666 18.6903 15.9381 20.32 17.9999 20.32C20.0617 20.32 21.7332 18.6903 21.7332 16.68C21.7332 14.6697 20.0617 13.04 17.9999 13.04ZM13.2 16.68C13.2 14.0953 15.349 12 17.9999 12C20.6508 12 22.7998 14.0953 22.7998 16.68C22.7998 19.2647 20.6508 21.36 17.9999 21.36C15.349 21.36 13.2 19.2647 13.2 16.68Z",
    fill: "#606DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.3593C16.7829 21.3593 15.5872 21.6718 14.5331 22.2652C13.479 22.8586 12.6038 23.7121 11.9953 24.7399C11.8481 24.9886 11.5219 25.0738 11.2668 24.9303C11.0117 24.7867 10.9243 24.4687 11.0715 24.22C11.7736 23.034 12.7835 22.0492 13.9997 21.3645C15.2159 20.6798 16.5956 20.3193 18 20.3193C19.4044 20.3193 20.7841 20.6798 22.0003 21.3645C23.2165 22.0492 24.2264 23.034 24.9285 24.22C25.0757 24.4687 24.9883 24.7867 24.7332 24.9303C24.4781 25.0738 24.1519 24.9886 24.0047 24.7399C23.3962 23.7121 22.521 22.8586 21.4669 22.2652C20.4128 21.6718 19.2171 21.3593 18 21.3593Z",
    fill: "#606DD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 13.04C15.9381 13.04 14.2666 14.6697 14.2666 16.68C14.2666 18.6903 15.9381 20.32 17.9999 20.32C20.0617 20.32 21.7332 18.6903 21.7332 16.68C21.7332 14.6697 20.0617 13.04 17.9999 13.04ZM13.2 16.68C13.2 14.0953 15.349 12 17.9999 12C20.6508 12 22.7998 14.0953 22.7998 16.68C22.7998 19.2647 20.6508 21.36 17.9999 21.36C15.349 21.36 13.2 19.2647 13.2 16.68Z",
    stroke: "#606DD2",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.3593C16.7829 21.3593 15.5872 21.6718 14.5331 22.2652C13.479 22.8586 12.6038 23.7121 11.9953 24.7399C11.8481 24.9886 11.5219 25.0738 11.2668 24.9303C11.0117 24.7867 10.9243 24.4687 11.0715 24.22C11.7736 23.034 12.7835 22.0492 13.9997 21.3645C15.2159 20.6798 16.5956 20.3193 18 20.3193C19.4044 20.3193 20.7841 20.6798 22.0003 21.3645C23.2165 22.0492 24.2264 23.034 24.9285 24.22C25.0757 24.4687 24.9883 24.7867 24.7332 24.9303C24.4781 25.0738 24.1519 24.9886 24.0047 24.7399C23.3962 23.7121 22.521 22.8586 21.4669 22.2652C20.4128 21.6718 19.2171 21.3593 18 21.3593Z",
    stroke: "#606DD2",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7926 9.33238C28.9025 9.44221 28.9025 9.62029 28.7926 9.73012L24.8551 13.6676C24.7453 13.7775 24.5672 13.7775 24.4574 13.6676L22.4886 11.6989C22.3788 11.589 22.3788 11.411 22.4886 11.3011C22.5985 11.1913 22.7765 11.1913 22.8864 11.3011L24.6562 13.071L28.3949 9.33238C28.5047 9.22254 28.6828 9.22254 28.7926 9.33238Z",
    fill: "#606DD2",
    stroke: "#606DD2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.932a20066fca55938ab8316cbf949b2d.svg";
export { ForwardRef as ReactComponent };